import React from "react";

export default function Label({ text }) {
  return (
    <label className="text-sm font-sfMedium text-text-color-900"> {text}</label>
  );
}
